import { render, staticRenderFns } from "./PaymentConfirming.vue?vue&type=template&id=2a588120&scoped=true&"
import script from "./PaymentConfirming.vue?vue&type=script&lang=js&"
export * from "./PaymentConfirming.vue?vue&type=script&lang=js&"
import style0 from "./PaymentConfirming.vue?vue&type=style&index=0&id=2a588120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a588120",
  null
  
)

export default component.exports